import React, { useState, useRef, useEffect } from 'react';
import {Button, Typography, Box, IconButton} from '@mui/material';
import AttendanceAddNewRecord from './AttendanceAddNewRecord'
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import AttendanceAddAbsences from './AttendanceAddAbsences';

function AttendanceListComponent({onRefresh, currentTime, idConfig, onPrevDay, onNextDay, dateString, onDateChange}) {
    //dodaj wpis forms
    const [openAddModal, setOpenAddModal] = useState(false)
    const [open, setOpen] = useState(false)

    //date picker
    const [selectedDate, setSelectedDate] = useState(dayjs(dateString))
    const anchorRef = useRef(null)

    useEffect(() => {
        setSelectedDate(dayjs(dateString))
    }, [dateString])

    //dodaj urlop form
    const [openAbsencesModal, setOpenAbsencesModal] = useState(false)



    return (
    <Box>
        <Box sx={{
            display: 'flex', 
            gap: 2, 
            ml:'20px', 
            mt: '20px', 
            justifyContent: 'space-between', 
            mb: '30px'}}>
            <Box sx={{display:'flex', alignItems: 'center'}}>
                <Typography variant='subtitle1' sx={{fontWeight: '500'}}> 
                    Lista obecności • {dateString}
                </Typography>
                <IconButton>
                    <ChevronLeftIcon 
                        sx={{color: 'black'}}
                        onClick={onPrevDay}/>
                </IconButton>
                
                <Box ref={anchorRef} sx={{ display: 'inline-flex' }}>
                    <IconButton onClick={() => setOpen(true)}>
                        <CalendarMonthIcon sx={{ color: 'black' }} />
                    </IconButton>
                    <DatePicker
                        open={open}
                        onClose={() => setOpen(false)}
                        value={selectedDate}
                        onChange={(newValue) => {
                            setSelectedDate(newValue);
                            onDateChange(newValue);
                        }}
                        slotProps={{
                            field: { sx: { display: 'none' } },
                            popper: { anchorEl: () => anchorRef.current },
                        }}
                    />
                </Box>

                <IconButton>
                <ChevronRightIcon sx={{color: 'black'}}
                    onClick={onNextDay}
                    ></ChevronRightIcon>
                </IconButton>
            </Box>
        <Box sx={{display: 'flex'}}>
            <Box sx={{pr: '10px'}}>
                <Button variant="outlined" onClick={() => setOpenAddModal(true)}>
                    +Dodaj wpis
                </Button>
            </Box>

             <Box sx={{pr: '10px'}}>
                <Button variant="outlined" onClick={() => setOpenAbsencesModal(true)}>
                    +Dodaj urlop
                </Button>
            </Box>
        </Box>
        </Box>

        <AttendanceAddNewRecord
            open={openAddModal}
            onClose={()=>setOpenAddModal(false)}
            onRefresh={onRefresh}
            currentTime={currentTime}
            idConfig={idConfig}
        />

        <AttendanceAddAbsences 
            open={openAbsencesModal}
            onClose={()=>setOpenAbsencesModal(false)}
            onRefresh={onRefresh}
            currentTime={currentTime}
            idConfig={idConfig}
        />

    </Box>

    )
}


export default AttendanceListComponent;